import {Box} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {INotificationSettings, NotificationSettings, NotificationType} from '../../../../api/api';
import {AppState} from '../../../../state/store';
import {GetColorByIndex} from '../../../../utilities/colors';
import {ColorRouter, ColorSquare} from '../color-square/color-square';
import NotificationSettingField from '../notification-setting-field/notification-setting-field';
import './notification-settings-container.scss';

interface PropsFromParents {
  deviceId?: string;
  deviceDataType?: string;
  index: number;
}

const mapStateToProps = (state: AppState, props: PropsFromParents) => {
  return {
    pendingStatus: state.notificationSettingsReducer.pending,
    notificationSettings: props.deviceId
      ? state.notificationSettingsReducer.notificationSettingsHashmap[props.deviceId]
      : [],
  };
};

type Props = Partial<ReturnType<typeof mapStateToProps>> & PropsFromParents;

class NotificationSettingsContainer extends PureComponent<Props> {
  defaultSettingLowBattery: INotificationSettings = {
    type: NotificationType.LowBattery,
    deviceId: this.props.deviceId,
    emailUserWhenExceedingLimit: false,
    limit: 5.2,
    isDeleted: false,
    id: 0,
    showNotificationWeb: false,
  };

  defaultSettingNitrat: INotificationSettings = {
    type: NotificationType.Nitrat,
    deviceId: this.props.deviceId,
    emailUserWhenExceedingLimit: false,
    limit: 0,
    isDeleted: false,
    id: 0,
    showNotificationWeb: false,
  };

  defaultSettingNitrateNitrogen: INotificationSettings = {
    type: NotificationType.NitrateNitrogen,
    deviceId: this.props.deviceId,
    emailUserWhenExceedingLimit: false,
    limit: 0,
    isDeleted: false,
    id: 0,
    showNotificationWeb: false,
  };

  private getValidNitrat = (nitrat?: NotificationSettings): INotificationSettings => {
    if (nitrat === undefined && this.props.pendingStatus === false) {
      return this.defaultSettingNitrat;
    } else {
      return nitrat!;
    }
  };

  private getValidBattery = (temperature?: NotificationSettings): INotificationSettings => {
    if (temperature === undefined && this.props.pendingStatus === false) {
      return this.defaultSettingLowBattery;
    } else {
      return temperature!;
    }
  };

  private getValidNitrateNitrogen = (nitrateNitrogen?: NotificationSettings): INotificationSettings => {
    if (nitrateNitrogen === undefined && this.props.pendingStatus === false) {
      return this.defaultSettingNitrateNitrogen;
    } else {
      return nitrateNitrogen!;
    }
  };

  // THIS METHOD DETERMINES THE DISPLAY ORDER OF THE TYPES
  private displaySettingsSorted = () => {
    if (this.props.notificationSettings) {
      let nitrat = this.props.notificationSettings.find((setting) => setting.type === NotificationType.Nitrat);
      nitrat = this.getValidNitrat(nitrat) as NotificationSettings;
      let lowBattery = this.props.notificationSettings.find((setting) => setting.type === NotificationType.LowBattery);
      lowBattery = this.getValidBattery(lowBattery) as NotificationSettings;
      let nitratNitrogen = this.props.notificationSettings.find(
        (setting) => setting.type === NotificationType.NitrateNitrogen,
      );
      if (this.props.deviceDataType === 'NitrateNitrogenLogTrans') {
        nitratNitrogen = this.getValidNitrateNitrogen(nitratNitrogen) as NotificationSettings;
      }

      return (
        <div key={this.props.deviceId}>
          {nitrat && <NotificationSettingField setting={nitrat} />}
          {nitratNitrogen && <NotificationSettingField setting={nitratNitrogen} />}
          {lowBattery && <NotificationSettingField setting={lowBattery} />}
        </div>
      );
    }

    if (this.props.notificationSettings === undefined && this.props.pendingStatus === false) {
      return (
        <div key={this.props.deviceId}>
          <NotificationSettingField setting={this.defaultSettingNitrat as NotificationSettings} />
          {this.props.deviceDataType === 'NitrateNitrogenLogTrans' && (
            <NotificationSettingField setting={this.defaultSettingNitrateNitrogen as NotificationSettings} />
          )}
          <NotificationSettingField setting={this.defaultSettingLowBattery as NotificationSettings} />
        </div>
      );
    }
  };

  public render() {
    return (
      <Box className="settingsContainer" display="flex" flexDirection="row">
        <Box display="flex" flexDirection="row" className="mobile colorRouter">
          <ColorRouter key={this.props.deviceId} color={GetColorByIndex(this.props.index)} />
        </Box>
        <Box className="settingsInner">
          <Box display="flex" flexDirection="row" className="formatBox">
            <Box display="flex" className="desktop">
              <ColorSquare key={this.props.deviceId} color={GetColorByIndex(this.props.index)} />
            </Box>
            <Box display="flex" className="sensorHeader">
              {this.props.deviceId}
            </Box>
          </Box>
          {this.displaySettingsSorted()}
        </Box>
      </Box>
    );
  }
}

export default connect(mapStateToProps, null)(NotificationSettingsContainer);
